import { Button } from "@/components/ui/button";
import { useTheme } from "@/components/theme-provider";
import { Sun, Moon, Monitor } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  const icon = {
    light: <Sun className="h-4 w-4 text-amber-400" />,
    dark: <Moon className="h-4 w-4 text-indigo-400" />,
  }[theme] ?? <Sun className="h-4 w-4" />;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8 transition-colors hover:bg-brand-tile-info/50"
          aria-label="Toggle theme"
        >
          {icon}
        </Button>
      </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-32">
          <DropdownMenuItem onClick={() => setTheme("light")}>
            <Sun className="mr-2 h-4 w-4 text-amber-400" /> Light
          </DropdownMenuItem>
        </DropdownMenuContent>
    </DropdownMenu>
  );
}

/* Optional: compact version (no dropdown) */
export function SimpleThemeToggle() {
  const { theme, setTheme } = useTheme();
  // Simple static light indicator — clicking keeps the app light-only.
  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={() => setTheme("light")}
      title={`Light mode (fixed)`}
      className="h-8 w-8 transition-colors hover:bg-brand-tile-info/50"
    >
      <Sun className="h-4 w-4 text-amber-400" />
    </Button>
  );
}
